import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import { NormalHeading } from "../../../../Components/Utils/Heading";

import CommonComments from "../../../../Components/Utils/commonComments";
import NuAmount from "../../../../Components/Utils/NuAmount";
import { Progress } from "antd";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";

import { useFormik } from "formik";
import { handleKeyDown } from "../../../../Components/Utils/OtherFunction";
import { MainForm, MainFormInput } from "../../../../Components/Utils/MainForm";
import FilesView from "../../../../Components/Utils/FilesView";
import * as yup from 'yup';
import { InputCheck, NuDate, NuInput, NuTextArea } from "../../../../Components/Utils/Input";
import NuDateFormat from "../../../../Components/Utils/NuDate";
import SurveyReportLayout from "./SurveyReportLayout";
import { GetAccess } from "../../../../Components/Utils/roles";
import axiosInstance from "../../../../Services/axiosCommon";
import PDFViewer from "../../../../Components/Utils/PDFViewer";
import ApprovalComponent from "../../../../Components/Utils/approvalComponent";
function ViewSurveyReports(onClose) {
  const { surveyReportViewId } = useParams();
  const location = useLocation();
  const sData = location.state?.data;
   
  const [data,setData] = useState(sData? sData:null);   
const[isSubmit,setisSubmited]=useState(false)
  function getView() {
    axiosInstance 
      .get(`/survey-report/getById/${surveyReportViewId}`)
      .then((res) => {
        setData(res.data?.data); 
        setisSubmited(res.data?.data?.isSubmited === true);       

      })
      .catch(err=>{
        console.log("err", err);
      })
  }
  
  useEffect(() => {
    // if (!sData) {
      getView();
    // }
  }, [surveyReportViewId])

  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [percentOpen, setPercentOpen] = useState(false);
 
  const [filePathList, setFilePathList] = useState([]);
 useEffect(() => {
     if (
       data?.attachments !== null &&
       data?.attachments !== "None" &&
       data?.attachments !== "[]"
     ) {
       setFilePathList(data?.attachments?.length>0 ? data?.attachments : []);
     }
   }, [data]);

   const [expandedIndex, setExpandedIndex] = useState(null);

   const handleToggle = (index) => {
     setExpandedIndex(index === expandedIndex ? null : index);
   };
   
  
 const formik = useFormik({
  enableReinitialize: true,
  initialValues: {
    clientDetails: { name: "", address: "" },
    inspectionDetails: { date: "", inspector: "" },
    serviceDetails: { serviceType: "", isUrgent: false },
    observation: { notes: "" }
  },
  validationSchema: yup.object({}),
  validateOnChange: false,
  validateOnBlur: false,
  onSubmit: (values) => {
    console.log("Submitting all data", values);
  }
});
const [showPdfComponent, setShowPdfComponent] = useState(false);

const handlePdfIconClick = () => {
  setShowPdfComponent(true);
};
const downloadPDF = async () => {
  try {
      const response = await axiosInstance.get(`/surveyInspectionForm/generate-report/${surveyReportViewId}`, {
          responseType: 'blob' // Important to specify the response type as blob
      });

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Create a link element
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `${data.ref}.pdf`; // The filename you want for the downloaded file

      // Append the link to the body (required for Firefox)
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);

  } catch (error) {
      console.error('Error downloading the PDF:', error);
  }
};
const [viewPDF,setViewPDF] = useState(null);
const [pdfLoading,setPdfLoading] = useState(false)

const ViewPDF = async () => {
  setPdfLoading(true)
  try {
      const response = await axiosInstance.get(`/surveyInspectionForm/generate-report/${surveyReportViewId}`, {
          responseType: 'blob' // Important to specify the response type as blob
      });

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Create a link element
      let Viewlink = window.URL.createObjectURL(pdfBlob);
      setViewPDF(Viewlink);
      setPdfLoading(false)
  } catch (error) {
      console.error('Error downloading the PDF:', error);
      setPdfLoading(false)
  }
};

useEffect(() => {
  ViewPDF()
},[surveyReportViewId,data])

const [pdfAvailable, setPdfAvailable] = useState(false);

  const getpdf = () => {
    axiosInstance
      .get(`/surveyInspectionForm/get-report/${surveyReportViewId}`)
      .then((res) => {
        if (res.data?.data === true) {
          // setPdfAvailable(true);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getpdf();
  }, []);


  const id = surveyReportViewId; 
  const getUrl = `/survey-report/get-status`;
  const putUrl = `/survey-report/edit-status`; 
  const statusUrl = '/survey-report/all-status';

  const hasSidebarContent =
  GetAccess("approvals") ||
  GetAccess("client_details") ||
  GetAccess("comments") 
  // pdfAvailable;

  return (
    
<SurveyReportLayout
EditAccess={GetAccess("survey_edit")}
  >

    {/* <div className="w-full h-full mt-0.5 overflow-y-auto "> */}
     
     
    <div className="w-full mx-auto h-[calc(100vh-160px)] mt-0.5    md:flex gap-x-2 text-[#111537]">
    <div className={`${hasSidebarContent ? "md:w-[70%]" : "w-full"} bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden`}>
          <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between items-center  z-10">
            <div className="grid  items-center ">
              <div className="flex text-[14px] mb-1 text-[#111537] font-semibold w-[100%]">
                {/* <p className="flex">Survey:</p> */}
                <p>{data?.refNumber || "None"}</p>
              </div>
              {/* <div className="flex gap-4 justify-between">
                <p className="text-xs text-[#111537]">Date : 05-03-2025</p>
              </div> */}
            </div>

             {/* <div className=" mt-1 sm:mt-0 border rounded-md mr-3 border-textColor-main text-xs inline-flex w-auto  flex-shrink-0  justify-center">
              <p className="  bg-white  text-black  p-1 rounded-l-md  ">
                Status{" "}
              </p>
              <p className="bg-textColor-main text-white p-1 items-center rounded-r-md">
                {" "}
                {data?.status || "None"}
              </p>
            </div> */}

             <div className=" flex items-center mt-2 sm:mt-0  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
                            <div className="  p-2 h-6  bg-white  rounded-s-full text-xs flex items-center border border-textColor-main">
                              Status{" "}
                            </div>
                            <div className="  p-2 h-6  bg-textColor-main text-white text-xs  rounded-e-full flex items-center">
                              {data?.status || "-"}
                            </div>
                          </div>
          </div>

          <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8 ">
            <div className=" w-full flex flex-wrap  px-2 border border-gary mt-2  rounded-lg ">
              <div className=" w-full sm:grid grid-cols-2 gap-x-8 ">
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                    Project
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.project}
                  </p>
                </div>
                {/* <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Inspector
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.inspector}
                  </p>
                </div> */}

                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Assignee
                  </p>
                  <div className="w-[65%] py-2 text-xs font-medium text-[#606279] flex flex-wrap">
  <span className="mr-1">:</span>
  {data?.assignee?.map((assignee, idx) => (
    <span key={idx} className="text-xs font-medium  text-[#606279] mr-1">
      {assignee.assigneeName}
      {idx < data.assignee.length - 1 && ','}
    </span>
  ))}
</div>

                </div>
               
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Location
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.location}
                  </p>
                </div>

              
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                    Inspection Date
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    :{" "}
                    {data?.inspectionDate ? (
                      <NuDateFormat
                        value={data?.inspectionDate}
                        format="DD-MMM-YYYY"
                      />
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="sm:flex gap-4 mt-4">
              <div className="sm:w-[50%]">
                <p className="text-xs font-medium text-[#111537] p-1">
                  Scope of Work
                </p>

                <div className="border border-gray h-28 overflow-y-scroll rounded-lg">
                  <p className="text-xs p-2 break-words text-[#606279]">
                    {data?.scope}{" "}
                  </p>
                </div>
              </div>
              <div className="sm:w-[50%] sm:mt-0 mt-2">
                <p className=" p-1 text-xs font-medium text-[#111537]">
                  Attachments
                </p>
                <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
                  
                  <div className="w-full flex gap-2 flex-wrap ">
                    {data?.attachments &&
                      filePathList.map((imgs, idx) => {
                        console.log("img", imgs);
                        return (
                          <FilesView fileView={imgs} key={idx} />
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
           



          </div>
        </div>

        {(GetAccess("approvals") || GetAccess("client_details") || GetAccess("comments")  || isSubmit) && (
        <div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg py-1 mt-3 md:mt-0">
          <div className="h-[98%] overflow-y-scroll p-2 ">
          {GetAccess("approvals") && isSubmit &&(
<ApprovalComponent id={id} getUrl={getUrl} putUrl={putUrl} statusUrl={statusUrl} refSetData={setData} data={data} type={"Survey"} preUrlName={"survey-report"}/>
 )}
{GetAccess("client_details") &&(
            <div className="w-full grid  border border-gary mt-2   rounded-lg">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Client Detail</p>
              </div>
              {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}

              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Name
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.clientName}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Reference
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.clientRefNumber}
                </p>
              </div>
            </div>
            )}

            {/* <div className="w-full border border-gray-300 rounded-lg mt-4 shadow-sm overflow-hidden h-20">
  <div className="bg-baseColor-primary p-2 rounded-t-lg flex justify-between">
    <p className="text-xs text-white font-semibold tracking-wide">Selected Forms</p>
    <div className="cursor-pointer" onClick={() => setShowLocationPopup(true)}>
  <MapPin size={15} color="#ffff" />
</div>

  </div>

  <div className="w-full px-3 py-2 overflow-y-auto h-52">
    {Array.isArray(data?.inspection) && data.inspection.length > 0 ? (
      (() => {
        // Collect all formSelectionName values
        const allFormNames = data.inspection
          .flatMap(item => item.formSelectionName || []);

        // Remove duplicates using Set
        const uniqueFormNames = [...new Set(allFormNames)];

        return uniqueFormNames.length > 0 ? (
          <div className="space-y-1">
            {uniqueFormNames.map((name, idx) => (
              <div
                key={idx}
                className="flex items-start gap-2 p-2 bg-white border border-gray-200 rounded-md text-xs text-gray-700 hover:bg-blue-50 transition"
              >
                <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-textColor-main font-semibold text-[10px]">
                  {idx + 1}
                </div>
                <p className="flex-1">{name}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-xs text-gray-500 py-2">No forms selected</p>
        );
      })()
    ) : (
      <p className="text-xs text-gray-500 py-2">No forms selected</p>
    )}
  </div>
</div> */}
           
            <div className="w-full grid  border border-gary mt-4  rounded-lg ">
           <p className="text-xs text-white font-medium bg-baseColor-primary  p-2 rounded-t-lg">Report </p>
           <div className=" w-full flex flex-wrap overflow-y-scroll h-16">
         

        <div onClick={handlePdfIconClick} className="cursor-pointer m-1 w-auto h-[25px] flex items-center  justify-between  rounded p-[2px] border ">
          <svg
            width="20"
            height="20"
            className="fill-current text-baseColor-primary"

            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
          </svg>
          <p className=' w-auto  text-[9px]'>{data?.refNumber}</p>
        </div>
        </div>
        </div>
           
            {/* {GetAccess("comments") &&(
            <div className="w-full h-auto flex  border border-gary mt-4 overflow-hidden rounded-lg">
              <CommonComments
                visible={true}
                title="Comments"
                mainId={data?.prId}
                addurl={"/pr-comments/new-comment"}
                geturl={`/pr-comments/by-PR/${data?.prId}`}
              />
            </div>
             )} */}
          </div>
        </div>
        )}
      </div>
    {/* </div> */}
    {showPdfComponent && (
  <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
  <div className="animate-scale-in relative w-[98%] h-[98%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
    <button
              className="absolute top-2 right-2 text-white bg-red-600"
              onClick={() => setShowPdfComponent(false)}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <PDFViewer pdfFile={viewPDF}/>
      
     
     
    </div>
  </div>
)}
     
    </SurveyReportLayout>

  );
}

export default ViewSurveyReports;
